import React from 'react'

import { BlogCard } from '@application/Interfaces/Features/BlogsThumbnailCards/BlogCard/BlogCard'
import { Pagination } from '@application/Interfaces/Organisms/Pagination'
import { HelpCenterListType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import Container from '@mui/material/Container'
import { CategoryList, CategoryListExpandable } from '@src/Application/Interfaces/Organisms/CategoryList'
import { SocialBanner } from '@src/Application/Interfaces/Organisms/SocialBanner'

import { CategoryWrapper, List, SideWrapper, Wrapper } from './HelpCenterListView.styled'
import { mapToBlogCard } from './utils'

export const HelpCenterListView = ({
    items,
    categories,
    prevPage,
    nextPage,
    socialBannerTitle,
    socialBannerDescription,
    facebookLink,
    linkedInLink,
    twitterLink,
    socialButtonUrl,
    socialButtonLabel,
    showSocialBanner,
}: HelpCenterListType): JSX.Element => {
    const categoryTitle = items[0].categories[0].title

    return (
        <Container>
            <CategoryWrapper>{categoryTitle}</CategoryWrapper>
            <Wrapper>
                <List>
                    <CategoryListExpandable categories={categories} label="categories" />
                    <Grid container>
                        {mapToBlogCard(items).map((item, i) => (
                            <Grid item xs={12} md={6} spacingBottom={10} key={`blog-item-${i}`}>
                                <BlogCard item={item} mode="Light" />
                            </Grid>
                        ))}
                    </Grid>
                    <Pagination prevPage={prevPage} nextPage={nextPage} />
                </List>

                <SideWrapper>
                    <CategoryList categories={categories} label="categories" />
                    <SocialBanner
                        socialBannerTitle={socialBannerTitle}
                        socialBannerDescription={socialBannerDescription}
                        facebookLink={facebookLink}
                        linkedInLink={linkedInLink}
                        twitterLink={twitterLink}
                        socialButtonUrl={socialButtonUrl}
                        socialButtonLabel={socialButtonLabel}
                        showSocialBanner={showSocialBanner}
                    />
                </SideWrapper>
            </Wrapper>
        </Container>
    )
}
